import * as Yup from 'yup';

export const ExportFormMetadataCustomConfigSchema = Yup.object().shape({
  '@type': Yup.string(),
  id: Yup.string(),
});
